module.exports = __webpack_public_path__ + "img/img-3-10.bf76c237.webp";